import { ROLES, ROLE_LABELS } from '../constants/roles';

const hasAnyRole = (role, allowed) => allowed.includes(role);

/**
 * Every role question the UI asks, answered in one place.
 *
 * All checks are membership tests against an explicit list, so no caller ever
 * implies an ordering between the role numbers — which matters, because they
 * carry none: DATA_MANAGER (1) is more privileged than USER (3).
 */
export default class RoleUtils {
  /** Label for a role, falling back to a readable value for unknown numbers. */
  static getRoleLabel(role) {
    if (role in ROLE_LABELS) return ROLE_LABELS[role];
    return role === undefined || role === null ? 'Unknown' : `Unknown (${role})`;
  }

  /** Users, Log Viewer, Data Matching — reserved for the superadmin. */
  static isAdmin(role) {
    return hasAnyRole(role, [ROLES.ADMIN]);
  }

  /** The whole Metadata Tools group, including CSV Uploader. */
  static canManageMetadata(role) {
    return hasAnyRole(role, [ROLES.DATA_MANAGER, ROLES.ADMIN]);
  }

  /** Manage Aggregations: everyone except a plain user. */
  static canManageAggregations(role) {
    return hasAnyRole(role, [ROLES.RESEARCHER, ROLES.DATA_MANAGER, ROLES.ADMIN]);
  }

  static canEditRecords(role) {
    return hasAnyRole(role, [ROLES.DATA_MANAGER, ROLES.ADMIN]);
  }

  /** Researchers get the bulk-select column on the indicators table. */
  static isResearcher(role) {
    return hasAnyRole(role, [ROLES.RESEARCHER]);
  }
}
